import type { DiningAvailabilityTimeslot, DiningPromotion } from './schemas';

export function isBookableSlot(
  slot: DiningAvailabilityTimeslot,
  promotions: DiningPromotion[]
): boolean {
  return (
    slot.hasStandardAvailability ||
    slot.availablePromotions.some((available) =>
      promotions.some((promotion) => promotion.id === available.id)
    )
  );
}
